import { Suspense, useContext, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Box } from '@mui/material/';
import { ToolContext } from '../core/context/ToolContext';
import { WebRoute } from "../core/webrouter/pslRoute";
import { InstallPromotion } from './components/layouts/installation/InstallPromotion';
import { rqx } from '../core/request/API';
import { env, key } from '../core/Env';
import { createPersonalization, getGlobalProfession } from '../core/request/Global';
import moment from 'moment';
import Lottie from 'react-lottie';
import AcadLoader from '../assets/json/Acd_Loader_v2';

const sessionData = localStorage.getItem('pof_acd_session');
const __SESSION = sessionData ? JSON.parse(sessionData) : null;
const tool_id =  process.env.REACT_APP_TID_PSL;

export const Core = () => {
	const { tool_state, install_state, home_state, personalization_state, navigation_state, training_state } = useContext(ToolContext)
	const { onboarding, MTlist, tlist, tclist } = {...personalization_state, ...tool_state}

	// const uid = window.atob(__SESSION.ainfo.aid).split('_').pop()
	let uid = null;
    if (__SESSION && __SESSION.ainfo && __SESSION.ainfo.aid) {
        try {
            uid = window.atob(__SESSION.ainfo.aid).split('_').pop();
        } catch (error) {
            console.error("Error decoding user ID:", error);
        }
    }
	
	const __installer = () => {
		window.addEventListener('beforeinstallprompt', (e) => {
			e.preventDefault();
			install_state.prompt.set(e)
			installPromptHandler()
		});
	}

	const installPromptHandler = () => {
		setTimeout(() => {
			// install_state.ip.set({stat: true, prompt_type: 'first_prompt'})
		}, 2000);
	}
	
	const __personalization = async (pinfo, profession) => {
		const attempt = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/personalization/read`, {tool_id: key('tid'), user_id: uid , ref: 'all'})
		let fonboarding = attempt.filter(f => f.feature_name === 'onboarding')
		let training = attempt.filter(f => f.feature_name === 'training')
		let onb = {...onboarding.data}
		
		// const pinfostat = pinfo.length > 0
		const profstat = profession.length > 0
		
		if (fonboarding.length === 0) {
			const sf = [
				{sf_name: 'profiling', status: profstat ? 1 : 0},
				{sf_name: 'welcome', status: profstat ? 1 : 0},
				{sf_name: 'home_tour', status: profstat ? 1 : 0},
			] 
			createPznHandler('onboarding', sf)
			
			if (!profstat) {
				onb.profiling = true
				onb.welcome = {stat: true, step: 1}
				onb.home_tour = {...onb.home_tour, stat: false, drawer: false}
			}
		} else {
			const pzn = JSON.parse(fonboarding[0].personalization)
			const profiling = pzn.filter(f => { return f.sf_name === 'profiling'})
			if (profiling[0].status === 0) onb.profiling = true
	
			const welcome = pzn.filter(f => { return f.sf_name === 'welcome'})
			if (welcome[0].status === 0) onb.welcome = {stat: true, step: 1}
	
			const home_tour = pzn.filter(f => { return f.sf_name === 'home_tour'})
			if (home_tour[0].status === 0) onb.home_tour = {...onb.home_tour, stat: true, drawer: true}
		}
		
		if (training.length === 0) {
			const sf = [
				{sf_name: 'sub_nav', status: profstat ? 1 : 0},
				{sf_name: 'sub_availed', status: profstat ? 1 : 0},
				{sf_name: 'sub_referral', status: profstat ? 1 : 0},
			] 
			createPznHandler('training', sf)

			if (!profstat) {
				onb.training.sub.nav = true
				onb.training.sub.availed = true
			}
		} else {
			const pzn = JSON.parse(training[0].personalization)
			const sub_nav = pzn.filter(f => { return f.sf_name === 'sub_nav'})
			if (sub_nav[0].status === 0) onb.training.sub.nav = true

			const sub_availed = pzn.filter(f => { return f.sf_name === 'sub_availed'})
			if (sub_availed[0].status === 0) onb.training.sub.availed = true
			
			const sub_referral = pzn.filter(f => { return f.sf_name === 'sub_referral'})
			if (sub_referral.length === 0) {
				const sf = [
					{sf_name: 'sub_nav', status: profstat ? 1 : 0},
					{sf_name: 'sub_availed', status: profstat ? 1 : 0},
					{sf_name: 'sub_referral', status: 0},
				] 
				createPznHandler('training', sf)
				onb.training.sub.referral = true
				return
			}
			if (sub_referral[0].status === 0) onb.training.sub.referral = true
		}
		
		onboarding.set(onb)

	}

	const createPznHandler = async (f, sf) => {
		let prsnl_data = {
			user_id: uid,
			tool_id: key('tid'), 
			feature_name: f,
			personalization: sf
		}

		await createPersonalization(prsnl_data);
	}
	
	useEffect(() => {
		const __init = async () => {
			// RUN AN API REQUEST HERE ( SAMPLE REQUESTS BELOW: )
			let ainfo = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/account/read`, {aid: __SESSION.ainfo.aid})
			let pinfo = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/primeinfo/read`, {aid: __SESSION.ainfo.aid})
			let uaccess = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/roleaccess/uap`, {aid: __SESSION.ainfo.aid, tid:tool_id})
			let uaddress = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/location/assigned`, {aid:__SESSION.ainfo.aid})
			let prof = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/profession/read`,{filter:'all'})
			await tool_state.__SESSION.set({ainfo, pinfo, uaccess, uaddress})
			
			let compileData = [...tool_state.profession.data, ...prof]
			tool_state.profession.set(compileData)

			//FOR ACAD API REQUEST OR READ/CREATE/UPDATE
			let au = await rqx.post(`<<global>>/${env()==='local'?'dev':env()}/trail/create`, {action:'signin',aid: __SESSION.ainfo.aid, date:moment(new Date()).format('YYYY-MM-DD'), tool_id:process.env.REACT_APP_TID_PSL })
			home_state.dau.set(au)

			let acd;
			let other;
			let total;
			let uaction = await rqx.get(`<<tool>>/${env()==='local'?'dev':env()}/dashboard/readUserAction`, {user_id: uid})
			
			if (uaction.acd.length > 0) { 
				acd = 1;
			} else {
				acd = 0;
			}
			if (uaction.other.length > 0) { 
				other = 1;
			} else {
				other = 0;
			}

			total =  acd + other;
			home_state.userA.set({...home_state.userA.data, acd: acd, other: other, total: total})

			let TCName = await rqx.get(`<<global>>/${env()==='local'? 'dev' : env()}/tools/categories`, {filter: [1]})
			let cart = await rqx.get(`<<global>>/${env()==='local'? 'dev' : env()}/tools/cart`, {aid: __SESSION.ainfo.aid, ref: 'list'})
			let nya = await rqx.get(`<<global>>/${env()==='local'? 'dev' : env()}/tools/read`, {filter: '!category', platform: 'personal', tcid: 'all'})
			let owned = await rqx.get(`<<global>>/${env()==='local'? 'dev' : env()}/tools/owned`, {aid: __SESSION.ainfo.aid, platform: 'personal'})
			
			owned.map(c => {
                nya = nya.filter(r => r.tid !== c.tid)
                return c
            })

			MTlist.set(owned)
			tlist.set({...tlist.data, owned: owned, cart, nya})
			navigation_state.TC_namelist.set(TCName)
			tclist.set(TCName)

			let req = {aid: ainfo.aid}
			
			const profession = await getGlobalProfession(req);
			
			// let profession = await rqx.get(`<<tool>>/${env()}/certificate/readProfession`, {user_id: uid})
			if(profession.length > 0){
				tool_state.getLicense.set(profession[0].license);
			}

			await __personalization(pinfo, profession);

			let newUploadTraining = await rqx.get(`<<tool>>/${env() === 'local' ? 'dev' : env()}/dashboard/new`)
			let newRecomendedTraining = await rqx.get(`<<tool>>/${env()}/dashboard/demand`)
			training_state.tnew.set(newUploadTraining)
			training_state.recommended.set(newRecomendedTraining)

            
			// SET STATES HERE ( SAMPLE STORING BELOW: )
			let d = new Date()
			d.setDate(d.getDate() + 30);
			localStorage.setItem('pof_acd_session', JSON.stringify({expiration: `${d.getMonth()+1}${d.getUTCDate()}${d.getUTCFullYear()}`, ainfo: ainfo}))
			tool_state.userId.set(parseInt(window.atob(ainfo.aid).split('_')[1]))
			tool_state.prefetch.set(true)
			// RUN PWA INSTALLATION PROMPT HANDLER
			// installPromptHandler()
		}
		
		if (__SESSION !== null) {
			__installer()
			__init()
		} else {
			setTimeout(() => {
				// SET STATES HERE ( SAMPLE STORING BELOW: )
				tool_state.prefetch.set(true)

				// RUN PWA INSTALLATION PROMPT HANDLER
				
				installPromptHandler()
			}, 1000);
		}
		
		console.log(`POFAcademy V4.03.54 is running`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const defaultOptions = {
		loop: true,
		autoplay: true, 
		animationData: AcadLoader,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice'
		}
	};

	return (
		<Box width="100%" height="100%" >
			{
				tool_state.prefetch.data ? (
					<Router>
						<Suspense fallback={
							<Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
								<Lottie options={defaultOptions} height={264} width={264} />
							</Box>
						}>
							<WebRoute personalization_state={personalization_state} training_state={training_state} tool_state={tool_state}/>
						</Suspense>
					</Router>
				) : (
					<Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
						<Lottie options={defaultOptions} height={264} width={264} />
					</Box>
				)
			}
			<InstallPromotion install_state={install_state} __SESSION={__SESSION} home_state={home_state} />
		</Box>
	)
}